import { createSlice } from '@reduxjs/toolkit';

const localIncidentsFilterSlice = createSlice({
    name: 'localIncidentsFilter',
    initialState: {
        isLoading: false,
        isError: false,
        error: false,
        isFetched: false,
        getAllRefStatus: [],
        getAllUsers: [],
    },
    reducers: {
        fetchAllRefStatusOption: (state, action) => {
            state.getAllRefStatus = action.payload;
            state.isLoading = false;
            state.isFetched = true;
        },
        fetchAllRefStatusOptionError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
            state.isFetched = false;
        },

        fetchAllUsersStart: (state) => {
            state.isLoading = true;
        },
        fetchAllUsersSuccess: (state, action) => {
            state.getAllUsers = action.payload;
            state.isLoading = false;
        },
        fetchAllUsersError: (state, action) => {
            state.isLoading = false;
            state.isError = true;
            state.error = action?.payload?.response?.data?.message;
        },
    },
});

export const {
    fetchAllRefStatusOption,
    fetchAllRefStatusOptionError,
    fetchAllUsersStart,
    fetchAllUsersSuccess,
    fetchAllUsersError,
} = localIncidentsFilterSlice.actions;

export default localIncidentsFilterSlice.reducer;
